import { TraitRegistryCategory } from '../../TraitRegistryCategory';
import { TraitTypeSelect } from '../../traitTypes/TraitTypeSelect';
import { TraitRegistryTextSize } from './TraitRegistryTextSize';
import { TraitTypeNumeric } from '../../traitTypes/TraitTypeNumeric';
import { TraitTypeHtml } from '../../traitTypes/TraitTypeHtml';
export class TraitRegistryText extends TraitRegistryCategory {
    label = 'Text';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_textSize = new TraitRegistryTextSize(this);
    textBasis = () => new TraitTypeHtml({
        default: 'Text',
    });
    initialFontSize = () => new TraitTypeNumeric({
        /*  label: 'Initiale Textgröße', */
        default: 14,
    });
    expectedWidth = () => new TraitTypeNumeric();
    expectedHeight = () => new TraitTypeNumeric();
    expectedTop = () => new TraitTypeNumeric();
    expectedLeft = () => new TraitTypeNumeric();
    transformText = () => new TraitTypeSelect({
        multiple: true,
        /*   label: 'Transform Text',
        select: [['removeUnderscores', 'associateOptionGap']] */
    });
    contentFillType = () => 
    // Was soll in die Lücke gefüllt werden? (Bei OrderedChoice)
    new TraitTypeSelect( /*{
      label: 'Was soll gefüllt werden',
      select: [['textBasis']]
    }*/);
}
